import { scheduleUpdateLatestActivity } from 'src/modules/profile/sagas/utils/scheduleUpdateLatestActivity';
import { emulateTransitionDelay } from 'src/modules/routing/hooks/emulateTransitionDelay';
import { fetchPartnerDashboard } from 'src/modules/routing/hooks/resolvers/fetchPartnerDashboard';
import { resetPartnerDashboard } from 'src/modules/routing/hooks/resolvers/resetPartnerDashboard';
import { createStateTransitionLoggingSaga } from 'src/modules/routing/hooks/stateTransitionLogging';
import { RouteState } from 'src/modules/routing/types/RouteState';
import { composeSagas } from 'src/modules/routing/utils/composeSagas';

export const ROUTING_DASHBOARD_STATES: ReadonlyArray<RouteState> = [
  {
    url: '/partner-dashboard',
    name: 'bp:partner-dashboard',
    parent: 'bp:authorized',

    onEntering: composeSagas(
      createStateTransitionLoggingSaga('Entering'),
      emulateTransitionDelay(0, 300),
      fetchPartnerDashboard,
    ),
    onLeaving: composeSagas(
      createStateTransitionLoggingSaga('Leaving'),
    ),
    onRetaining: composeSagas(
      createStateTransitionLoggingSaga('Retaining'),
    ),

    onEntered: composeSagas(
      createStateTransitionLoggingSaga('Entered'),
      scheduleUpdateLatestActivity,
    ),
    onLeft: composeSagas(
      createStateTransitionLoggingSaga('Left'),
      resetPartnerDashboard,
    ),
    onRetained: composeSagas(
      createStateTransitionLoggingSaga('Retained'),
      scheduleUpdateLatestActivity,
    ),
  },
];
